// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoBlock_wrapper__SPf0s","light":"VideoBlock_light__9WH_1","desc":"VideoBlock_desc__rQKKO","dark":"VideoBlock_dark__KTLLq"};